import React from 'react'
import styled from 'styled-components'
import { Button } from '@ui-library/core'
import { AddBold, LessBold } from '@ui-library/icons'

const capitalize = word => word.charAt(0).toUpperCase() + word.substring(1)

const CustomPlusIcon = styled(AddBold)``

const CustomMinusIcon = styled(LessBold)``

const CustomUIButton = styled(Button)`
  margin-top: 16px;
  padding: 0px;
  font-size: 14px;
  line-height: 18px;
  height: 18px;
  font-weight: 600;

  ${CustomPlusIcon} {
    width: 14px;
  }

  ${CustomMinusIcon} {
    width: 14px;
  }
`

const ListLinkButton = ({ collapsed, wording, toggleCollapse }) => (
  <CustomUIButton size="medium" kind="primary" variant="text" icon={collapsed ? CustomPlusIcon : CustomMinusIcon} iconPosition="left" onClick={toggleCollapse}>
    <span>
      {collapsed ? 'Plus' : 'Moins'} de {capitalize(wording.plural)}
    </span>{' '}
  </CustomUIButton>
)

export default ListLinkButton
